module.exports = __webpack_public_path__ + "img/360-white.9f78ff27.svg";